import './Navbar.scss';
import logo from 'assets/Lendit-logo.png';
import {
  AppBar,
  Tab,
  Tabs,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  useMediaQuery,
  Toolbar,
  Avatar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CONSTANTS, INPUT_BACKGROUND_COLOR, PRIMARY_COLOR, TERTIARY_COLOR } from 'utils';
import { AuthButton } from './AuthButtons';
import { useAppSelector } from 'state/store';
import { CreateProductButton } from './CreateProductButton';
import { setLogout } from 'state/slice/authSlice';
import { useDispatch } from 'react-redux';

export interface IPage {
  url: string;
  label: string;
}

const pages: IPage[] = [
  { label: "Inicio", url: CONSTANTS.PAGES.HOME },
  { label: "Sobre nosotros", url: CONSTANTS.PAGES.ABOUT_US },
  { label: "Contacto", url: CONSTANTS.PAGES.CONTACT },
];

export const NavBar = () => {
  const [value, setValue] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedUser = useAppSelector((state) => state.auth.user);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const foundIndex = pages.findIndex((p) => p.url === location.pathname);
    if (foundIndex !== -1) setValue(foundIndex);
  }, [location.pathname]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    navigate(pages[newValue].url);
  };

  const handleDrawerClick = (url: string) => {
    setDrawerOpen(false);
    navigate(url);
  };

  const handleLogout = () => {
    setDrawerOpen(false);
    dispatch(setLogout());
  };

  return (
    <AppBar sx={{ backgroundColor: TERTIARY_COLOR  }}>
      <Toolbar>
        <div className="toolbar-container">
          <div className="image-container">
            <img style={{ width: "150px", height: "50px" }} src={logo} alt="logo" />
          </div>

          {isMobile ? (
            <>
              <IconButton onClick={() => setDrawerOpen(true)} sx={{ mr: 'auto' }}>
                <MenuIcon style={{ color: PRIMARY_COLOR }} />
              </IconButton>
              <Box sx={{ ml: 'auto', display: "flex", alignItems: "center" }}>
                <img style={{ width: "120px", height: "40px" }} src={logo} alt="logo" />
              </Box>

              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{
                  sx: {
                    backgroundColor: TERTIARY_COLOR,
                    color: PRIMARY_COLOR,
                    width: "200px",
                    pt: 4
                  }
                }}
              >
                <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                  <img style={{ width: "120px", height: "40px" }} src={logo} alt="logo" />
                </Box>
                <List sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 2,
                  gap: 1,
                }}>
                  {pages.map((page, index) => (
                    <ListItem
                      key={index}
                      onClick={() => handleDrawerClick(page.url)}
                      sx={{ justifyContent: 'center' }}
                      button
                    >
                      <ListItemText
                        primary={page.label}
                        sx={{ textAlign: 'center' }}
                      />
                    </ListItem>
                  ))}

                </List>
              </Drawer>

            </>
          ) : (
            <>
              <div className="tabs-container">
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  variant="fullWidth"
                >
                  {pages.map((page, index) => (
                    <Tab key={index} label={page.label} />
                  ))}
                </Tabs>
              </div>
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
};
